import React, { useState, useMemo, useCallback } from "react";
import {
  FaFolderOpen,
  FaFileAlt,
  FaPrint,
  FaSearch,
  FaChevronRight,
  FaChevronDown,
} from "react-icons/fa";
import "./ReportPage.css";
import { useLocation } from "react-router-dom";
import { BASE_URL } from "../../constants";

/* ─────────── FORMS (folders) ─────────── */
const FORMS_DATA = [
  {
    title: "Personal & Identification",
    data: [
      "Driver's License",
      "Vehicle Registration",
      "Health Card (OHIP)",
      "Proof of Address",
    ],
  },
  {
    title: "Accident & Scene Evidence",
    data: [
      "Accident Photos/Videos",
      "Police or MTO Report",
      "Witness Statements",
    ],
  },
  {
    title: "Employer & Income",
    data: [
      "Employer Letter/OCF-2 Form",
      "Pay Stubs/Income Proof",
      "Insurance Policy Documents",
      "Lawyer Retainer Agreement",
      "Settlement Offers/Payment Proof",
    ],
  },
  {
    title: "Client Identification",
    data: [
      "Retain Agreement",
      "ID Verification",
      "Consent/Authorization Forms",
    ],
  },
  {
    title: "Medical & Treatment",
    data: [
      "Insurance Policy",
      "Claim Correspondence",
      "OCF Forms (1,2,3 Series)",
      "Settlement Offers/Meditation Notes",
    ],
  },
  {
    title: "Finance & Accounting",
    data: [
      "Assesment Reports",
      "Account Summaries/Invoices and Outstanding Balances",
      "Treatment Plans(OCF-18/OCF-23)",
      "Clinic Referrals & Progress Updates",
    ],
  },
  {
    title: "Patient Registration",
    data: [
      "Intake Form/Consent",
      "Doctor's Referral",
      "Patient ID/Insurance Info",
    ],
  },
  {
    title: "Billing & HCAI",
    data: [
      "Initial Assesment(OCF-18/OCF-23)",
      "Progress Notes/Reports",
      "Account Summaries",
    ],
  },
  {
    title: "Communication & Notes",
    data: [
      "Emails/Letters",
      "Call Logs/Meeting Notes",
      "Internal Clinic Notes",
    ],
  },
  {
    title: "Correspondence",
    data: ["Communication with Lawyer", "Internal Clinic Notes"],
  },
];

const slugify = (s) =>
  String(s)
    .toLowerCase()
    .trim()
    .replace(/[\s/–—]+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-");

const formsTree = FORMS_DATA.map((group) => ({
  label: group.title,
  children: (group.data || []).map((item) => ({
    label: item,
    id: slugify(`${group.title}-${item}`),
  })),
}));

function TreeNode({ node, path, onSelect }) {
  const [open, setOpen] = useState(false);
  const hasChildren = node.children && node.children.length > 0;
  const handleClick = () => (hasChildren ? setOpen((o) => !o) : onSelect(path));

  return (
    <div className="tree-node">
      <div className="tree-label" onClick={handleClick}>
        {hasChildren ? (
          open ? (
            <FaChevronDown />
          ) : (
            <FaChevronRight />
          )
        ) : (
          <span className="tree-spacer" />
        )}
        <FaFolderOpen className="tree-icon" />
        <span>{node.label}</span>
      </div>
      {hasChildren && open && (
        <div className="tree-children">
          {node.children.map((child, idx) => (
            <TreeNode
              key={idx}
              node={child}
              path={[...path, child.label]}
              onSelect={onSelect}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default function ReportPage() {
  const location = useLocation();
  const clientId =
    location?.state?.client?.id || location?.state?.clientId || null;
  // const clientId = "CB97BABF-0450-49D2-B4D1-A5C9BB6378F9";
  const first =
    location?.state?.client?.first_name || location?.state?.first_name || "";
  const last =
    location?.state?.client?.last_name || location?.state?.last_name || "";
  const clientName = first && last ? `${first} ${last}` : "Unknown Client";

  console.log(clientId, clientName);
  console.log("Hiiiiiiiiiiiiiiiii");

  const [filter, setFilter] = useState("Stored reports");
  const [search, setSearch] = useState("");
  const [selectedPath, setSelectedPath] = useState([]);
  const [rows, setRows] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const buildQuery = (path, minutesToLive = 60) => {
    const params = new URLSearchParams();
    if (path?.[0]) params.append("folderSection", path[0]);
    if (path?.[1]) params.append("folderName", path[1]);
    params.append("minutesToLive", String(minutesToLive));
    return params.toString();
  };

  const fetchUploadHistory = useCallback(
    async (path) => {
      if (!clientId) {
        setErr("No clientId in location.state");
        setRows([]);
        setSelectedFile(null);
        return;
      }
      setLoading(true);
      setErr("");
      setSelectedFile(null);

      const qs = buildQuery(path, 60);
      const url = `${BASE_URL}/api/upload-history/client/${encodeURIComponent(
        clientId
      )}${qs ? `?${qs}` : ""}`;

      try {
        const resp = await fetch(url);
        const json = await resp.json();
        if (!resp.ok || !json?.success)
          throw new Error(json?.error || `HTTP ${resp.status}`);

        const mapped = (json.data || []).map((f) => ({
          date: new Date(f.uploadedAt).toLocaleString(),
          name: f.name,
          reference:
            f.folderSection || f.sectionCategory || f.folderName || "—",
          status: "—",
          url: f.url,
          _raw: f, // includes .url for preview
        }));
        console.log("m", mapped);
        setRows(mapped);
      } catch (e) {
        setErr(e.message || String(e));
        setRows([]);
      } finally {
        setLoading(false);
      }
    },
    [clientId]
  );

  const handleSelect = (path) => {
    setSelectedPath(path);
    fetchUploadHistory(path);
  };

  const filteredRows = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter(
      (r) =>
        r.name.toLowerCase().includes(q) ||
        String(r.reference).toLowerCase().includes(q) ||
        String(r.status).toLowerCase().includes(q) ||
        String(r.date).toLowerCase().includes(q)
    );
  }, [rows, search]);

  return (
    <div className="reports-page">
      <div className="toolbar">
        <button>
          <FaFileAlt /> Select All
        </button>
        <button>Unselect All</button>
        <button
          disabled={!selectedFile?.url}
          onClick={() =>
            selectedFile?.url && window.open(selectedFile.url, "_blank")
          }
        >
          <FaFileAlt /> View Report
        </button>
        <button
          disabled={!selectedFile?.url}
          onClick={() =>
            selectedFile?.url && window.open(selectedFile.url, "_blank")
          }
        >
          <FaPrint /> Print
        </button>
        <div className="spacer" />
        <select value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option>Ad hoc reports</option>
          <option>Stored reports</option>
          <option>Views</option>
        </select>
        <input
          type="text"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button className="search-btn">
          <FaSearch />
        </button>
        <span className="advanced-search">Advanced Search</span>
      </div>

      <div className="main-panel">
        <div className="rp-sidebar">
          <div className="client-info">
            Client: <strong>{clientName}</strong>
          </div>
          {formsTree.map((node, idx) => (
            <TreeNode
              key={idx}
              node={node}
              path={[node.label]}
              onSelect={handleSelect}
            />
          ))}
        </div>

        <div className="table-container">
          <div className="file-path">
            {selectedPath.length > 0
              ? selectedPath.join(" / ")
              : "No folder selected"}
          </div>

          {err && <div className="error-banner">{err}</div>}

          {loading ? (
            <div className="loading">Loading…</div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Name</th>
                  <th>Reference</th>
                  <th>Archive Status</th>
                </tr>
              </thead>
              <tbody>
                {filteredRows.map((r, i) => (
                  <tr
                    key={`${r.name}-${i}`}
                    onClick={() => setSelectedFile(r._raw)}
                    className={"rp-selected"}
                    title="Click to preview"
                  >
                    <td>{r.date}</td>
                    <td>{r.name}</td>
                    <td>{r.reference}</td>
                    <td>{r.status}</td>
                  </tr>
                ))}
                {filteredRows.length === 0 && (
                  <tr>
                    <td
                      colSpan={4}
                      style={{ textAlign: "center", color: "#777" }}
                    >
                      {selectedPath.length
                        ? "No files in this folder yet."
                        : "Pick a folder to see files."}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}

          {selectedFile?.url && (
            <div className="pdf-preview">
              <h3>Preview: {selectedFile.name}</h3>
              <iframe
                src={selectedFile.url}
                title="Blob Viewer"
                width="100%"
                height="600px"
                style={{ border: "1px solid #ccc", marginTop: "10px" }}
              />
            </div>
          )}
        </div>
      </div>

      <div className="pagination">
        <button disabled>&lt;&lt;</button>
        <button>&lt;</button>
        <span>1 of 5</span>
        <button>&gt;</button>
        <button>&gt;&gt;</button>
        <div className="alpha-filter">
          {"ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").map((c) => (
            <button key={c}>{c}</button>
          ))}
        </div>
      </div>
    </div>
  );
}
